import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-assessment-dialog',
  templateUrl: './assessment-dialog.component.html',
  styleUrls: ['./assessment-dialog.component.scss']
})
export class AssessmentDialogComponent implements OnInit {

  assessmentType = 'PopupWindow';
  id: number = 0;
  templateNo: number = 1;
  templateNoForAssess:number = 1;
  isForAssessedAtChangeViewer = false;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public id: number,  @Inject(MAT_DIALOG_DATA) public templateNo: number
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data && this.data.length > 0) {
      this.id = this.data[0];
    }
    if (this.data && this.data.length > 1) {
      this.templateNo = this.data[1];
    }
  }

  ngOnInit(): void {
  }

}
